import type { SupportedMimeType } from '../types/worker-messages';

const SUPPORTED_MIME_TYPES: Set<string> = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/avif',
  'image/tiff',
  'image/heic',
  'image/heif',
  'image/gif',
  'image/svg+xml',
]);

const EXTENSION_TO_MIME: Record<string, SupportedMimeType> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  avif: 'image/avif',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  heic: 'image/heic',
  heif: 'image/heif',
  gif: 'image/gif',
  svg: 'image/svg+xml',
};

export function detectMimeType(file: File): SupportedMimeType | null {
  if (file.type && SUPPORTED_MIME_TYPES.has(file.type)) {
    return file.type as SupportedMimeType;
  }

  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  return EXTENSION_TO_MIME[ext] ?? null;
}
